'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
const defaults = {
  overallRating: 0,
  reviewCount: 0
};
/**
 * @deprecated use marketplace-ui-reviews/records
 */

class ReviewSummary extends Immutable.Record(defaults) {
  constructor(json = {}) {
    super(cleanObject(json));
  }

}

export default ReviewSummary;